var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.328 37.8279C25.3419 37.8279 26.1639 37.006 26.1639 35.9921C26.1639 34.9782 25.3419 34.1562 24.328 34.1562C23.3141 34.1562 22.4922 34.9782 22.4922 35.9921C22.4922 37.006 23.3141 37.8279 24.328 37.8279Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4506 11.2617H19.2074C18.6332 11.2617 18.166 11.7071 18.166 12.2536V31.6165C18.166 32.1634 18.6329 32.6083 19.2074 32.6083H29.4506C30.0248 32.6083 30.492 32.1629 30.492 31.6165V12.2536C30.4917 11.7067 30.0248 11.2617 29.4506 11.2617Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3275 0.570312C11.3493 0.570312 0.828125 11.0923 0.828125 24.07C0.828125 37.0477 11.3493 47.5706 24.3275 47.5706C37.3057 47.5706 47.8281 37.0484 47.8281 24.07C47.8281 11.0916 37.3057 0.570312 24.3275 0.570312ZM33.4703 35.6672C33.4703 37.4623 32.0149 38.9179 30.2196 38.9179H18.436C16.6409 38.9179 15.1853 37.4624 15.1853 35.6672V12.371C15.1853 10.5759 16.6408 9.1203 18.436 9.1203H30.2196C32.0147 9.1203 33.4703 10.5757 33.4703 12.371V35.6672Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco10);
export default __webpack_public_path__ + "static/media/ico-10.6001540c7ece1d27c6259b7a81ea38dc.svg";
export { ForwardRef as ReactComponent };